import React from 'react'
import PropTypes from 'prop-types'
import resolveScopedStyles from '../../utils/resolveScopedStyles'
import styles from './styles'

const scoped = resolveScopedStyles(
  <scope><style jsx>{styles}</style></scope>
)

const ButtonRounded = ({
  text,
  href,
  theme,
  fullWidth,
  icon,
  uppercase,
  className,
  inactive,
  fontSize,
  ...props
}) => {
  const Element = href ? 'a' : 'button'
  const classNames = [
    'ButtonRounded',
    scoped.className,
    Array.isArray(theme) ? theme.join(' ') : theme,
    fullWidth && 'full-width',
    inactive && 'is-inactive',
    icon && 'has-icon',
    uppercase && 'uppercase',
    className,
  ]
    .filter(Boolean)
    .join(' ')
  const style = fontSize && {
    style: { fontSize },
  }
  const buttonType = Element === 'button' ? { type: 'button' } : {}

  return (
    <Element
      {...buttonType}
      {...props}
      {...style}
      href={href}
      className={classNames}
    >
      { text }
      { icon && icon }
      { scoped.styles }
    </Element>
  )
}

const theme = PropTypes.oneOf([
  '',
  'light',
  'dark',
])

ButtonRounded.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string,
  fontSize: PropTypes.string,
  theme: PropTypes.oneOfType([
    theme,
    PropTypes.arrayOf(theme),
  ]),
  fullWidth: PropTypes.bool,
  icon: PropTypes.element,
  uppercase: PropTypes.bool,
  className: PropTypes.string,
  inactive: PropTypes.bool,
}

ButtonRounded.defaultProps = {
  href: null,
  fontSize: '',
  theme: '',
  fullWidth: false,
  icon: null,
  uppercase: false,
  className: '',
  inactive: false,
}

export default ButtonRounded
